function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}

export { _isTransformer as default };
